var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1711 10.1928L17.723 9.47943C17.9107 9.40434 18.0608 9.25416 18.0608 9.02888C18.0608 8.80361 17.9107 8.65342 17.723 8.57833L15.1711 7.86496C12.8069 7.18914 11.0055 5.38694 10.33 3.0591L9.61696 0.505981C9.50438 0.092977 8.82887 0.092977 8.71629 0.505981L8.00325 3.0591C7.32775 5.42448 5.5264 7.22668 3.16213 7.86496L0.610214 8.57833C0.422573 8.65342 0.272461 8.80361 0.272461 9.02888C0.272461 9.25416 0.422573 9.40434 0.610214 9.47943L3.16213 10.1928C5.5264 10.8686 7.32775 12.6708 8.00325 14.9987L8.71629 17.5518C8.79134 17.7395 8.94146 17.8897 9.16663 17.8897C9.39179 17.8897 9.54191 17.7395 9.61696 17.5518L10.33 14.9987C11.0055 12.6333 12.8069 10.8311 15.1711 10.1928Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.5ad8cd2c7afd724e00ca1272b3375723.svg";
export { ForwardRef as ReactComponent };